<article class="content-card" appDisableClickEvent (click)="fireGAEvent(); goTo()">
  <img [src]="image.filename + sbFormatParam" [alt]="image.alt" />
  <h2>{{ title }}</h2>
  <p class="subtext">{{ subtext }}</p>
  <p class="details">{{ linkedText || 'SHARED.SHOW_DETAILS.LABEL' | translate }}</p>
</article>
